document.addEventListener("DOMContentLoaded", function () {
  const filterBtns = document.querySelectorAll('[data-filter-category]');
  const filterYearSelect = document.getElementById('filter-year');
  const sortOrderSelect = document.getElementById('sort-order');
  const filterLabel = document.querySelector('.filter-label');
  const filterBox = document.querySelector('.filter-box');
  const activeFiltersList = document.getElementById('active-filters-list');
  const clearAllFiltersBtn = document.getElementById('clear-all-filters');

  const activeFilters = {
    categories: [],
    year: '',
    sortOrder: ''
  };

  function updateActiveFiltersDisplay() {
    activeFiltersList.innerHTML = '';

    // Mostrar filtros de categoria
    activeFilters.categories.forEach((category) => {
      const tag = document.createElement('div');
      tag.className = 'active-filter-tag';
      tag.innerHTML = `
        ${category}
        <span class="remove-filter" data-remove-category="${category}">×</span>
      `;
      activeFiltersList.appendChild(tag);

      tag.querySelector('.remove-filter').addEventListener('click', function () {
        removeFilter('category', category);
      });
    });

    // Mostrar filtro de ano
    if (activeFilters.year) {
      const tag = document.createElement('div');
      tag.className = 'active-filter-tag';
      tag.innerHTML = `
        ${activeFilters.year}
        <span class="remove-filter" data-remove-year>×</span>
      `;
      activeFiltersList.appendChild(tag);

      tag.querySelector('.remove-filter').addEventListener('click', function () {
        removeFilter('year');
      });
    }

    // Mostrar ordenação
    if (activeFilters.sortOrder) {
      const sortText = activeFilters.sortOrder === 'asc' ? 'A > Z' : 'Z &lt; A';
      const tag = document.createElement('div');
      tag.className = 'active-filter-tag';
      tag.innerHTML = `
        ${sortText}
        <span class="remove-filter" data-remove-sort>×</span>
      `;
      activeFiltersList.appendChild(tag);

      tag.querySelector('.remove-filter').addEventListener('click', function () {
        removeFilter('sort');
      });
    }

    // Habilitar/desabilitar botão de limpar
    const hasFilters = activeFilters.categories.length > 0 || activeFilters.year || activeFilters.sortOrder;
    if (hasFilters) {
      clearAllFiltersBtn.style.display = 'inline-block';
    } else {
      clearAllFiltersBtn.style.display = 'none';
    }
  }

  function emitFilterChange() {
    document.dispatchEvent(new CustomEvent('mediateca-filter-change', {
      detail: {
        categories: activeFilters.categories,
        year: activeFilters.year,
        sortOrder: activeFilters.sortOrder
      }
    }));
  }

  function removeFilter(type, value) {
    if (type === 'category') {
      activeFilters.categories = activeFilters.categories.filter(cat => cat !== value);
      // Desmarcar botão
      const btn = document.querySelector(`[data-filter-category="${value}"]`);
      if (btn) btn.classList.remove('active');
    } else if (type === 'year') {
      activeFilters.year = '';
      if (filterYearSelect) filterYearSelect.value = '';
    } else if (type === 'sort') {
      activeFilters.sortOrder = '';
      if (sortOrderSelect) sortOrderSelect.value = '';
    }

    updateActiveFiltersDisplay();
    emitFilterChange();
  }

  // Click para abrir/fechar filtros
  if (filterLabel) {
    filterLabel.addEventListener('click', function (e) {
      e.preventDefault();
      if (filterBox) {
        filterBox.classList.toggle('active');
        filterLabel.classList.toggle('active');
      }
    });
  }

  // Filtros por categoria
  filterBtns.forEach((btn) => {
    btn.addEventListener('click', function () {
      const category = this.getAttribute('data-filter-category');
      const index = activeFilters.categories.indexOf(category);

      if (index > -1) {
        activeFilters.categories.splice(index, 1);
        this.classList.remove('active');
      } else {
        activeFilters.categories.push(category);
        this.classList.add('active');
      }

      updateActiveFiltersDisplay();
      emitFilterChange();
    });
  });

  // Filtro por ano
  if (filterYearSelect) {
    filterYearSelect.addEventListener('change', function () {
      activeFilters.year = this.value;
      updateActiveFiltersDisplay();
      emitFilterChange();
    });
  }

  // Ordenação
  if (sortOrderSelect) {
    sortOrderSelect.addEventListener('change', function () {
      activeFilters.sortOrder = this.value;
      updateActiveFiltersDisplay();
      emitFilterChange();
    });
  }

  // Limpar todos os filtros
  if (clearAllFiltersBtn) {
    clearAllFiltersBtn.addEventListener('click', function () {
      activeFilters.categories = [];
      activeFilters.year = '';
      activeFilters.sortOrder = '';

      filterBtns.forEach(btn => btn.classList.remove('active'));
      if (filterYearSelect) filterYearSelect.value = '';
      if (sortOrderSelect) sortOrderSelect.value = '';

      updateActiveFiltersDisplay();
      emitFilterChange();
    });
  }
});
